module.exports = __webpack_public_path__ + "img/5.08bf21d8.jpg";